import React from 'react';
import cn from 'clsx';
import {useTheme} from 'styled-components';
import {CustomIcon, ErrorMessage} from '@guestapp/old-ui-kit';
import {ButtonStepper, Container, Number, CounterSize, getIconSize} from './styled';

type CounterProps = {
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  readOnly?: boolean;
  error?: string | boolean;
  minNumber?: number;
  maxNumber?: number;
  size?: CounterSize;
  className?: string;
};

const Counter = ({
  value,
  error,
  onChange,
  disabled,
  readOnly,
  minNumber = 0,
  maxNumber = 20,
  size,
  className,
}: CounterProps) => {
  const theme = useTheme();
  return (
    <Container className={cn('counter', className, 'kiosko:w-auto')} size={size}>
      {!readOnly && (
        <ButtonStepper
          disabled={disabled || value === minNumber}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            const checkedValue = value ?? 0;
            if (checkedValue < 1) return;

            !disabled && onChange?.(checkedValue - 1);
          }}
          type="button"
          $hasError={!!error}
          aria-label="Decrease"
          className={cn(
            'counter__decrease-button counter__button',
            'kiosko:w-[64px] kiosko:h-[64px]',
            'kiosko:[&_.custom-icon]:w-12 kiosko:[&_.custom-icon]:h-12',
          )}
        >
          <CustomIcon
            name="minus"
            size={getIconSize(size)}
            color={theme.colors.branding.primary}
            className={cn('kiosko:w-12 kiosko:h-12')}
          />
        </ButtonStepper>
      )}
      <Number
        $hasError={!!error}
        className={cn('counter__value', 'kiosko:text-kiosko-s')}
      >
        {value}
      </Number>
      {!readOnly && (
        <ButtonStepper
          disabled={disabled || value === maxNumber}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            const checkedValue = value ?? 0;

            !disabled && onChange?.(checkedValue + 1);
          }}
          $hasError={!!error}
          type="button"
          className={cn(
            'counter__increase-button counter__button',
            'kiosko:w-[64px] kiosko:h-[64px]',
            'kiosko:[&_.custom-icon]:w-12 kiosko:[&_.custom-icon]:h-12',
          )}
          aria-label="Increase"
        >
          <CustomIcon
            name="plus"
            size={getIconSize(size)}
            color={theme.colors.branding.primary}
            className="kiosko:w-12 kiosko:h-12"
          />
        </ButtonStepper>
      )}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export {Counter};
